import styled, { css } from 'styled-components';

import { colors } from 'global/colors';

export const Block = styled.div`
  width: 100%;
`;

export const BackgroundPreview = styled.span.attrs(({ backgroundColor }) => ({
  style: { background: backgroundColor },
}))`
  display: block;
  width: 100%;
  height: 68px;
  padding: 0.375rem 0.75rem;
  border: 1px solid ${colors.borderGray};
  border-radius: 8px;
  margin-top: 0.5rem;
`;

export const LandingPageImage = styled.img`
  margin-top: 0.5rem;
  max-height: 450px !important;
  max-width: 100% !important;
`;

export const UploadFileButton = styled.button`
  height: 25px;
  width: 25px;
  border-radius: 50%;
  background-color: transparent;
  margin-top: -0.5rem;
  color: ${colors.fsDarkBlue};
  font-size: 1.5rem;
  border: 0;
`;

export const PlusIcon = styled.i.attrs({ className: 'fa fa-plus-circle' })``;

export const GraphicsImagesContainer = styled.div``;

export const GraphicsImageRow = styled.div`
  width: 100%;
  display: flex;
  gap: 5px;
  border-top: 1px solid ${colors.borderGray};
`;

export const GraphicsImageCell = styled.div`
  padding: 0.5rem;
  ${({ overflowHidden }) =>
    overflowHidden &&
    css`
      overflow: hidden;
    `}
  ${({ push }) =>
    push &&
    css`
      margin-left: auto;
    `}
`;

export const GraphicsImage = styled.img`
  max-height: 2em;
  max-width: 5em;
`;

export const SheetIcon = styled.i.attrs({ className: 'fa fa-file-code-o' })`
  cursor: pointer;
  ${({ darkBlue }) =>
    darkBlue &&
    css`
      color: ${colors.fsDarkBlue};
    `}
`;

export const DeleteIcon = styled.i.attrs({ className: 'fa fa-trash' })`
  cursor: pointer;
  color: ${colors.fsDarkBlue};
`;

export const ModalInput = styled.input`
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  margin-top: 0.75rem;
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
`;

export const ModalJsonInput = styled.textarea`
  display: block;
  width: 100%;
  height: calc(20em + 0.75rem + 2px);
  margin-top: 0.75rem;
  padding: 0.375rem 0.75rem;
  color: ${colors.darkGray};
  border: 1px solid ${colors.borderGray};
  border-radius: 0.25rem;
  &:focus {
    outline: 0;
  }
`;
